import { gql } from "@apollo/client";

export const UPDATE_OFFENSE_IN_INCIDENT_ALL_FIELDS = gql`
  mutation addOrUpdateOffenseInIncident(
    $input: AddOrUpdateOffenseInIncidentInput!
  ) {
    addOrUpdateOffenseInIncident(input: $input) {
      clientMutationId
      errors
      incidentUuid
      incidentOffenseUuid
      incidentOffense {
        incident {
          id
          uuid
        }
        assaultTypes {
          id
          name
          oriId
          position
        }
        campusCode {
          id
          name
          oriId
          position
        }
        committedType {
          id
          name
          oriId
          position
        }
        counts
        criminalActivityTypes {
          id
          name
          oriId
          position
        }
        entryPointType {
          id
          name
          oriId
          position
        }
        exitPointType {
          id
          name
          oriId
          position
        }
        forceNoForceType {
          id
          name
          oriId
          position
        }
        id
        justifiableHomicideType {
          id
          name
          oriId
          position
        }
        locationType {
          id
          name
          oriId
          position
        }
        nibrsViolationType {
          id
          name
          oriId
          position
        }
        numberOfPremisesEntered
        offenseGangAffiliateds {
          id
          name
          oriId
          position
        }
        offenseIbrDesignation {
          id
          name
          oriId
          position
        }
        offenseViolationPrototype {
          id
          maxPenalty
          minPenalty
          fullName
          name
          offenseCategory {
            id
            name
            oriId
            position
          }
          offenseSubCategory {
            id
            name
            oriId
            position
          }
          oriId
          points
          waiver
          yoe
        }
        offenseWeaponTypes {
          id
          name
          oriId
          position
        }
        significantEvent {
          id
          name
          oriId
          position
        }
        suspectVictimAffiliations {
          sealed
          biasType {
            id
            name
            oriId
            position
          }
          ibrSuspectVictimRelationshipType {
            id
            name
            oriId
            position
          }
          id
          leokaNarrative
          suspect {
            id
            personalAttribute {
              id
              firstName
              lastName
            }
          }
          svaOri {
            abbreviation
            agencyType
            id
            oriName
          }
          victim {
            id
            personalAttribute {
              id
              firstName
              lastName
            }
          }
          victimLeoAssignment {
            id
            name
            oriId
            position
          }
          victimLeoState {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
